var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsArrowRight = function SvgIconsArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 6L8 10 4 6z",
    transform: "translate(-170.000000, -576.000000) translate(56.000000, 261.000000) translate(110.000000, 0.000000) translate(0.000000, 306.000000) translate(12.000000, 17.000000) rotate(-90.000000) translate(-12.000000, -17.000000) translate(4.000000, 9.000000)"
  })));
};
export default SvgIconsArrowRight;